import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Icon } from '@/components/ui/Icon';
import { Colors } from '@/constants/Colors';
import { useTheme } from '@/hooks/useTheme';

const TABS = [
  { path: '/', label: 'Matchs', icon: 'football', iconOutline: 'football-outline' },
  { path: '/map', label: 'Carte', icon: 'map', iconOutline: 'map-outline' },
  { path: '/scout', label: 'Scouting', icon: 'analytics', iconOutline: 'analytics-outline' },
  { path: '/favorites', label: 'Favoris', icon: 'star', iconOutline: 'star-outline' },
  { path: '/clubs', label: 'Clubs', icon: 'shield', iconOutline: 'shield-outline' },
];

export function TabBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const colors = useTheme();

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className="tifosi-safe-area-pad-bottom"
      style={{
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: colors.background,
        borderTop: `1px solid ${Colors.primary}15`,
        paddingTop: 8,
        flexShrink: 0,
        marginTop: 'auto',
      }}
    >
      {TABS.map((tab) => {
        const active = isActive(tab.path);
        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 4,
              padding: 0,
              cursor: 'pointer',
            }}
          >
            <Icon
              name={active ? tab.icon : tab.iconOutline}
              size={24}
              color={active ? Colors.primary : colors.tabIconDefault}
            />
            <span
              style={{
                fontSize: 10,
                fontWeight: 500,
                color: active ? Colors.primary : colors.tabIconDefault,
              }}
            >
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
